import * as React from 'react';
import { Fade, Card, CardContent, Typography, CircularProgress, makeStyles, Theme, createStyles } from '@material-ui/core';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    progress: {
      margin: theme.spacing(2),
    },
  }),
);

const Loading = () => {
    const classes = useStyles();

    return (
        <Fade in={true}>
            <div>
                <div style={{ width: '250px', margin: 'auto', textAlign: 'center',  marginTop: '10%' }}>

                    <Card >

                        <CardContent>
                            <CircularProgress className={classes.progress} />
                            <Typography gutterBottom={true} >
                                One moment ...
  </Typography>
                        </CardContent>
                    </Card >
                </div>
            </div>
        </Fade>
    );
}

export default Loading;